import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/AddCircleOutline";
//Limitless imports
import HeaderIconButton from "../header-icon-button/HeaderIconButton";
const useStyles = makeStyles(theme => ({
  titleContainer: {
    display: "flex",
    alignItems: "center",
    height: 40
  },
  icon: {
    color: theme.palette.secondary.main,
    "&:disabled": {
      color: theme.palette.contrast.text
    }
  }
}));
const CreateItemTitleButton = ({
  title,
  onClick,
  tooltip,
  buttonId,
  titleVariant,
  showAddIcon,
  addIconDisabled,
  disabledToolip
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.titleContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: titleVariant,
    color: "textPrimary"
  }, title), showAddIcon && /*#__PURE__*/React.createElement(HeaderIconButton, {
    onButtonClick: onClick,
    tooltip: addIconDisabled ? disabledToolip : tooltip,
    buttonId: buttonId,
    icon: /*#__PURE__*/React.createElement(AddIcon, {
      className: addIconDisabled ? "" : classes.icon
    }),
    disabled: addIconDisabled
  }));
};
export default CreateItemTitleButton;
CreateItemTitleButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  tooltip: PropTypes.string,
  buttonId: PropTypes.string,
  titleVariant: PropTypes.string,
  showAddIcon: PropTypes.bool,
  addIconDisabled: PropTypes.bool,
  disabledToolip: PropTypes.string
};
CreateItemTitleButton.defaultProps = {
  titleVariant: "h6",
  showAddIcon: true,
  addIconDisabled: false,
  disabledToolip: ""
};